import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Lokální nastavení", -1)
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Čas zobrazení objednávky na displeji obsluhy po jejím dokončení: (sekund)", -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Čas blikání objednávky na displeji pro lidi po jjím dokončení: (sekund)", -1)
const _hoisted_6 = ["onClick"]

import { useLocalSettings } from '@/services/LocalSettings';
import { OrderService } from '@/services/OrderService';
import { useShopHub } from '@/services/ShopHub';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LocalSettings',
  setup(__props) {

const localSettings = useLocalSettings();

const time1 = ref(localSettings.StaffFinishedOrderShowTime);
const time2 = ref(localSettings.DisplayFinishedOrderShowTime);

function saveIt(){
    localSettings.save(time1.value,time2.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "number",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((time1).value = $event))
        }, null, 512), [
          [_vModelText, time1.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "number",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((time2).value = $event))
        }, null, 512), [
          [_vModelText, time2.value]
        ])
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _withModifiers(saveIt, ["prevent"])
      }, "Uložit", 8, _hoisted_6)
    ])
  ]))
}
}

})